const LOAD = 'server-sts/lastEvents/LOAD';
const LOAD_SUCCESS = 'server-sts/lastEvents/LOAD_SUCCESS';
const LOAD_FAIL = 'server-sts/lastEvents/LOAD_FAIL';


import _ from 'underscore'


 
const initialState = {
  loaded: false,
  loading: false,
  success: false,
  error: false,
  data: [],
  count:0, 
  begin_date:null,
  end_date:null

};

function removeDuplicates(myArr, prop) {
  return myArr.filter((obj, pos, arr) => {
      return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
  });
}

export default function reducer(state = initialState, action = {}) {


  switch (action.type) {

    
    case LOAD:
      return {
        ...state,
        loading: true,
        chunkIndex:action.index
      };

    case LOAD_SUCCESS:

      const {result} = action

      return {
        ...state,
        loading: false,
        loaded: true,
        data: result,
        error: false,
      };
      

    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: [],
        error: action.error
      };



    default:
      return state;
  }
}

export function isLoaded(globalState) {
  return globalState.lastEvents.data && globalState.lastEvents.loaded;
}


export function load(params, begin_date, end_date) {
  return {
    promise: (lastEvents) => lastEvents.post('/lastEvents/load', { data: { params, begin_date, end_date } }),
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],

  };
}